<template>
  <Loading text="Fetching data. This might take up to a minute." v-if="!hasFetchedData" />
  <div v-else>
    <div style="height: 200px; overflow-y: visible" v-if="!venueId">
      <h5 class="mb-2 mt-2">Select a venue</h5>
      <vs-row>
        <venue-selector v-model="selectedVenues" :multiple="false" />
      </vs-row>
    </div>

    <div class="text-center mt-10" v-if="selectedVenues.length === 0 && !venueId">
      <h3 class="mt-10">Select a venue to get started</h3>
    </div>
    <div v-else>
      <vs-row class="align-center justify-start mb-4"
        ><h3>Statistics</h3>
        <small class="ml-2"
          ><a class="cursor-pointer" @click="showStatistics = !showStatistics">{{ showStatistics ? "Hide" : "Show" }}</a></small
        ></vs-row
      >
      <div class="vx-row" v-if="showStatistics">
        <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Number of badges">
            <ul>
              <li v-for="(num, idx) in badgeDivision.series" :key="idx" class="flex mb-3 justify-between">
                <span class="flex items-center">
                  <span
                    class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
                    :style="{
                      'border-color': colors[idx]
                    }"
                  ></span>
                  <span class=""
                    >Employees with <strong>{{ idx }}</strong> badges
                  </span>
                </span>
                <span
                  ><strong>{{ num }}</strong> <feather-icon icon="UserIcon" class="inline-block ml-2" svgClasses="h-4 w-4 " @click="hide()"
                /></span>
              </li>
            </ul>
          </vx-card>
        </div>

        <!--         <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Number of badges">
            <vue-apex-charts
              type="pie"
              :options="badgeDivision.chartOptions"
              :series="badgeDivision.series"
            />
          </vx-card>
        </div> -->

        <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Type of badges">
            <vue-apex-charts type="pie" :options="badgeTypes.chartOptions" :series="badgeTypes.series" />
          </vx-card>
        </div>

        <div class="vx-col w-full lg:w-1/3 mb-base">
          <vx-card title="Levels">
            <vue-apex-charts type="pie" :options="levelDivision.chartOptions" :series="levelDivision.series" />
          </vx-card>
        </div>

        <!--  -->
      </div>
      <div v-for="(venue, idx) in filteredVenues" :key="idx">
        <vs-row style="margin-bottom: -3.5em">
          <div>
            <vs-row v-if="true || !venueId">
              <h3>Employee list</h3>
              <!--<a class="ml-2" @click="toggleVisibility(venue.venueId)">
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </a>-->
            </vs-row>
            <br />

            <p>
              <strong>{{ venue.users.length }}</strong> employees.
              <strong>{{ venue.users.filter(e => e.numCompleted > 0).length }}</strong>
              with at least one badge.
              <strong>{{ venue.users.filter(e => e.numCompleted === 10).length }}</strong>
              with all badges. They have on average
              <strong>{{ Math.round(venue.users.reduce((a, b) => a + b.numCompleted, 0) / venue.users.length) }}</strong>
              badges
            </p>
          </div></vs-row
        >
        <vs-row>
          <vs-table max-items="999" pagination search :data="venue.users" style="width: 100%">
            <template slot="thead">
              <vs-th>Image</vs-th>
              <vs-th sort-key="displayName">Name</vs-th>
              <vs-th sort-key="positionLevel">Campus level</vs-th>
              <vs-th sort-key="numCompleted">Number of badges</vs-th>
              <vs-th sort-key="numCompelted">Badges</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="item.userId" v-for="item in data">
                <vs-td>
                  <img
                    class="rounded-full profile-image"
                    :src="profilePicture(item.userId)"
                    onerror="this.src='https://i.imgur.com/pH8JUMc.png'"
                  />
                </vs-td>
                <vs-td :data="item.displayName">
                  {{ item.displayName }}
                </vs-td>
                <vs-td :data="item.numCompleted"> Level {{ item.positionLevel }} ({{ item.positionLevelSince | formatDate }}) </vs-td>
                <vs-td :data="item.numCompleted"> {{ item.numCompleted }} Badges </vs-td>
                <vs-td>
                  <badge-row :badges="item.badges" />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-row>
      </div>
    </div>
  </div>
</template>

<script>
import analyticsData from "@/views/ui-elements/card/analyticsData.js";
import VueApexCharts from "vue-apexcharts";
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
import BadgeRow from "./BadgeRow.vue";
import VenueSelector from "@/components/VenueSelector.vue";

export default {
  props: {
    venueId: {
      type: String,
      default: null
    }
  },
  components: { BadgeRow, VenueSelector, VueApexCharts },
  data() {
    return {
      showStatistics: true,
      hasFetchedData: false,
      moment,
      selectedVenues: []
    };
  },
  computed: {
    ...mapGetters({
      userId: "users/userId",
      venues: "payrates/userVenuesDetails"
    }),
    filteredVenues() {
      return this.venues.filter(e => this.selectedVenues.length > 0 && this.selectedVenues.includes(e.venueId));
    },
    badgeDivision() {
      const getUsersWithNBadges = n =>
        this.filteredVenues
          .map(e => e.users)
          .flat()
          .filter(e => e.numCompleted === n).length;
      const all = {
        chartOptions: {
          ...analyticsData.productOrdersRadialBar.chartOptions,
          labels: [
            "Users with 0 badges",
            "Users with 1 badge",
            "Users with 2 badges",
            "Users with 3 badges",
            "Users with 4 badges",
            "Users with 5 badges",
            "Users with 6 badges",
            "Users with 7 badges",
            "Users with 8 badges",
            "Users with 9 badges",
            "Users with 10 badges",
            "Users with 11 badges"
          ]
        },
        series: [
          getUsersWithNBadges(0),
          getUsersWithNBadges(1),
          getUsersWithNBadges(2),
          getUsersWithNBadges(3),
          getUsersWithNBadges(4),
          getUsersWithNBadges(5),
          getUsersWithNBadges(6),
          getUsersWithNBadges(7),
          getUsersWithNBadges(8),
          getUsersWithNBadges(9) /*  */,
          getUsersWithNBadges(10),
          getUsersWithNBadges(11)
        ]
      };

      return all;
    },
    colors() {
      return analyticsData.productOrdersRadialBar.chartOptions.colors;
    },
    badgeTypes() {
      // Number of badges with label
      const getNumBadgesWithLabel = label =>
        this.filteredVenues
          .map(e => e.users)
          .flat()
          .map(e => e.badges)
          .flat()
          .filter(e => e.title === label && e.isEarned).length;

      const all = {
        chartOptions: {
          dataLabels: {
            enabled: true,
            formatter: function (val, opt) {
              return Math.round(opt.w.config.series[opt.seriesIndex]);
            }
          },
          ...analyticsData.productOrdersRadialBar.chartOptions,
          labels: [
            "Playbook",
            "WinWin",
            "Ambassador",
            "Walk Your Talk",
            "Masterclass",
            "Bartender Performance",
            "Runner Performance",
            "Wardrobe/Cover Perf..",
            "Host Performance",
            "Shiftmanager Perfor..",
            "Waiter Performance"
          ]
        },
        series: [
          getNumBadgesWithLabel("Playbook"),
          getNumBadgesWithLabel("WinWin"),
          getNumBadgesWithLabel("Ambassador"),
          getNumBadgesWithLabel("Walk Your Talk"),
          getNumBadgesWithLabel("Masterclass"),
          getNumBadgesWithLabel("Bartender Performance"),
          getNumBadgesWithLabel("Runner Performance"),
          getNumBadgesWithLabel("Wardrobe/Cover Performance"),
          getNumBadgesWithLabel("Host Performance"),
          getNumBadgesWithLabel("Shiftmanager Performance"),
          getNumBadgesWithLabel("Waiter Performance")
        ]
      };

      return all;
    },
    levelDivision() {
      // get number of users level n
      const getNumUsersWithLevel = n =>
        this.filteredVenues
          .map(e => e.users)
          .flat()
          .filter(e => e.positionLevel === n).length;
      const all = {
        chartOptions: {
          ...analyticsData.productOrdersRadialBar.chartOptions,
          dataLabels: {
            enabled: true,
            formatter: function (val, opt) {
              return Math.round(opt.w.config.series[opt.seriesIndex]);
            }
          },
          labels: ["Users currently level 0", "Users currently level 1", "Users currently level 2", "Users currently level 3"]
        },

        series: [getNumUsersWithLevel(0), getNumUsersWithLevel(1), getNumUsersWithLevel(2), getNumUsersWithLevel(3)]
      };

      return all;
    }
  },

  methods: {
    profilePicture(userId) {
      return `https://rekomlifestorageprod.blob.core.windows.net/user-uploads/avatars/${userId}.jpg`;
    },
    async fetchData() {
      await this.$store.dispatch("payrates/getUserVenuesDetails", false);
      console.log("Got data", this.venues);
      this.hasFetchedData = true;
    }
  },
  async mounted() {
    console.log("Employees report mounted with", this.venueId);
    if (this.venueId) {
      this.selectedVenues = [this.venueId];
    }
    await this.fetchData();
  }
};
</script>

<style lang="scss">
.apexcharts-datalabels.legend-mouseover-inactive {
  opacity: 1 !important;
}

.profile-image {
  object-fit: cover;
  width: 50px;
  height: 50px;
}

#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}

#profile-tabs > div.con-ul-tabs > ul > li:nth-child(4) {
  list-style-position: inside;
  border-bottom: 1px solid #b3b3b3;
  margin-right: 10px;
}
</style>